<template>
    <div>
<!--        <Breadtabsheader/>-->
        <div class="h-content">
            <!--查询-->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="经销商编码或名称">
                            <el-input v-model="q.customerCodeLike" :clearable="true"></el-input>
                        </el-form-item>

                        <el-form-item label="渠道">
                            <brselectlazy category="sales_region"
                                          v-model="q.salechannelCode"  :v="q.salechannelCode" :clearable="true"/>
                        </el-form-item>

                        <el-form-item label="年份">
                            <el-select v-model="q.year"  placeholder="请选择" clearable>
                                <el-option label="2026" :value=2026></el-option>
                                <el-option label="2027" :value=2027></el-option>
                                <el-option label="2028" :value=2028></el-option>
                                <el-option label="2029" :value=2029></el-option>
                                <el-option label="2030" :value=2030></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="季度">
                            <el-select v-model="q.quarter" :clearable="true"
                                       placeholder="请选择">
                                <el-option label="第一季度" :value=1></el-option>
                                <el-option label="第二季度" :value=2></el-option>
                                <el-option label="第三季度" :value=3></el-option>
                                <el-option label="第四季度" :value=4></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-collapse-transition>
                        <div v-show="isScreen">
                            <div class="h-thirdColumn w-newColumn" >

                                <el-form-item label="省区" class="h-elformWrap-2" prop="saleareaCode" >
                                    <brselect category="YlSalesArea_chanpin" :v="q.saleareaCode" v-model="q.saleareaCode" clearable
                                              style="width:100%"/>
                                </el-form-item>

                                <el-form-item label="活动类型">
                                    <el-select v-model="q.activityType"  placeholder="请选择" clearable>
                                        <el-option label="高校巡展/实验室安全讲座演练" value="高校巡展/实验室安全讲座演练"></el-option>
                                        <el-option label="渠道客户会/用户会" value=渠道客户会/用户会></el-option>
                                        <el-option label="润心巡检" value="润心巡检"></el-option>
                                        <el-option label="区域展会" value="区域展会"></el-option>
                                        <el-option label="学术会" value="学术会"></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="创建月份" >
                                    <el-date-picker
                                        :clearable="true"
                                        v-model="q.createMonth"
                                        type="month"
                                        style="width: 100%;"
                                        value-format="yyyy-MM"
                                        placeholder="--月份--">
                                    </el-date-picker>
                                </el-form-item>

                            </div>

                        </div>
                    </el-collapse-transition>


                </el-form>
                <div class="l-screenBox">
                    <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                    </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData()">重置</el-button>
                    </div>
                </div>


            </div>
            <!--查询end-->

            <!--数据展示-->
            <div class="h-table h-mrt30">

                <el-table
                    ref="ddtable"
                    :data="tableData"
                    stripe
                    border
                    max-height="600"
                    style="width: 100%"
                    header-cell-class-name="table-header-gray"
                >
                    <!-- 序号列 -->
                    <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        fixed
                    />
                    <!-- 客户信息 -->
                    <el-table-column
                        prop="customerCode"
                        label="客户编码"
                        width="120"
                        fixed
                    />
                    <el-table-column
                        prop="customerName"
                        label="客户名称"
                        min-width="150"
                        fixed
                    />
                    <el-table-column label="省区"
                                     class="h-elformWrap-2"
                                     prop="saleareaCode"
                                     width="100"
                                     :show-overflow-tooltip="true" >
                        <template slot-scope="scope">
                            {{scope.row.saleareaCode | dictname('YlSalesArea_chanpin')}}
                        </template>
                    </el-table-column>

                    <el-table-column label="销售渠道"
                                     class="h-elformWrap-2"
                                     prop="salechannelCode"
                                     width="100"
                                     :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            {{scope.row.salechannelCode | dictname('sales_region_ct')}}
                        </template>
                    </el-table-column>

                    <!-- 人员信息 -->
                    <el-table-column
                        prop="networkManagerName"
                        label="网络运营经理"
                        width="150"
                    />

                    <el-table-column
                        prop="yewuname"
                        label="专员"
                        width="80"
                    />
                    <el-table-column
                        prop="yewphone"
                        label="联系方式"
                        width="100"
                    />

                    <!-- 活动信息 -->
                    <el-table-column
                        prop="activityType"
                        label="活动类型"
                        width="200"
                        show-overflow-tooltip
                    >

                        <template #default="scope">
                            <div v-html="getDetailListField(scope.row,'activityType')"></div>
                        </template>
                    </el-table-column>


                    <el-table-column
                        prop="activityName"
                        label="活动名称"
                        min-width="150"
                        show-overflow-tooltip
                    >
                        <template #default="scope">
                            <div v-html="getDetailListField(scope.row, 'activityName')"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="activityTime"
                        label="活动时间"
                        min-width="200"
                    >
                        <template #default="scope">
                            <div v-html="getDetailListField(scope.row, 'activityTime')"></div>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="activityFee"
                        label="活动费用总额"
                        width="120"
                        align="right"
                    >
                        <template #default="scope">
                            <div v-html="getDetailListField(scope.row, 'activityFee')"></div>
                        </template>
                    </el-table-column>


                    <el-table-column
                        prop="photoUrls"
                        label="活动附件"
                        min-width="200"
                        show-overflow-tooltip
                    >
                        <template #default="scope">
                            <!-- 新逻辑：从 detailList.fileInfoList 获取 -->
                            <div v-if="scope.row.detailList && scope.row.detailList.length" class="photo-segments-container">
                                <div
                                    v-for="(detail, index) in scope.row.detailList"
                                    :key="index"
                                    class="photo-segment-item"
                                >
                                    <div v-if="detail.fileInfoList && detail.fileInfoList.length" class="segment-content">
                                        <el-link
                                            type="primary"
                                            size="small"
                                            @click="handleViewGroupPhotosNew(detail.fileInfoList)"
                                            class="view-btn"
                                        >
                                            <i class="el-icon-view"></i> 查看本组 ({{ detail.fileInfoList.length }}张)
                                        </el-link>
                                    </div>
                                </div>
                            </div>
                            <!-- 旧逻辑：从 photoUrls 获取 -->
                            <div v-else-if="scope.row.photoUrls" class="photo-segments-container">
                                <div
                                    v-for="(segmentStr, index) in scope.row.photoUrls.split(';')"
                                    :key="index"
                                    class="photo-segment-item"
                                >
                                    <div v-if="segmentStr.trim()" class="segment-content">
                                        <el-link
                                            type="primary"
                                            size="small"
                                            @click="handleViewGroupPhotos(segmentStr)"
                                            class="view-btn"
                                        >
                                            <i class="el-icon-view"></i> 查看本组 ({{ getGroupCount(segmentStr) }}张)
                                        </el-link>
                                    </div>
                                </div>
                            </div>
                            <div v-else>-</div>


                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="matchCount"
                        label="本季度提交场次"
                        width="80"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column label="二次确认可计入场次" :show-overflow-tooltip="true">

                        <el-table-column
                            prop="confirmStandardNum"
                            label="金额及场次确认"
                            width="140"
                            align="center"
                        >
                            <template #default="scope">
                                <div
                                    class="editable-cell"
                                    @click="openEditDialogNew(scope.row)"
                                    style="cursor: pointer; padding: 4px 0; color: #333;"
                                >
                                    <span style="margin-left: 4px; color: #409EFF; font-size: 12px;">点击确认</span>
                                    <i class="el-icon-edit" style="margin-left: 4px; color: #409EFF; font-size: 12px;"></i>
                                </div>
                            </template>

                        </el-table-column>


                        <!-- === 列 2: 确认金额 (只读 + 点击触发) === -->
                        <el-table-column
                            prop="confirmAmount"
                            label="总确认金额(万元)"
                            width="100"
                            align="right"
                        >
                        </el-table-column>

                        <el-table-column
                            prop="confirmFeePerson"
                            label="金额确认人"
                            width="120"
                            align="right"
                        >
                            <template #default="scope">
                                <div v-html="getDetailListField(scope.row, 'confirmFeePerson')"></div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="confirmStandardNum"
                            label="总计入场次"
                            width="100"
                            align="center"
                        >
                        </el-table-column>

                        <el-table-column
                            prop="confirmPerson"
                            label="场次计入人"
                            width="120"
                            align="right"
                        >
                            <template #default="scope">
                                <div v-html="getDetailListField(scope.row, 'confirmPerson')"></div>
                            </template>
                        </el-table-column>




                    </el-table-column>


                    <el-table-column label="上传附件"  min-width="200">
                        <template slot-scope="scope">
                            <brupload
                                :refid="scope.row.id"
                                reftype="市场推广季度报表-上传附件"
                                :uploadflag="false"
                                :delflag="false"
                                :showtime="false">
                            </brupload>
                            <el-button size="small" type="primary"   @click="uoloadFile(scope.row)">上传附件</el-button>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="year"
                        label="年度"
                        width="80"
                        align="center"
                    />
                    <el-table-column
                        prop="quarter"
                        label="季度"
                        width="80"
                        align="center"  >
                        <template slot-scope="scope">
                            <!-- 直接拼接字符串，数据库的 1 会变成 "Q1" -->
                            <span>{{ 'Q' + scope.row.quarter }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="yewuStandard"
                        label="专员达标判定"
                        width="120"
                    />
<!--                    <el-table-column
                        prop="yewuStandardUser"
                        label="专员达标判定人"
                        width="120"
                    />-->
                    <!-- 结算与金额计算 (BigDecimal 字段) -->
                    <el-table-column
                        prop="fulfilledAmountOver80"
                        label="80%以上履约额(万元)"
                        width="130"
                        align="right"
                    />
                    <el-table-column
                        prop="coefficient"
                        label="兑现系数"
                        width="100"
                        align="center"
                        :formatter="formatPercent"
                    />


                    <el-table-column
                        v-if="!this.isDls"
                        prop="payableAmount"
                        label="应兑现金额(万元)"
                        width="120"
                        align="right"
                    />
                    <el-table-column
                        prop="settlementAmount"
                        label="可兑现金额(万元)"
                        width="120"
                        align="right"
                    />
<!--                    <el-table-column
                        prop="actualSettledAmount"
                        label="实际兑现"
                        width="120"
                        align="right"
                    />-->
<!--                    <el-table-column
                        prop="ye"
                        label="余额"
                        width="120"
                        align="right"
                    />-->
<!--                    <el-table-column label="操作" width="80" fixed="right">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                :disabled="!canApproved"
                                class="h-tableLink h-btn"
                                @click="updateApproved(scope.row)">
                                审核通过
                            </el-button>

                        </template>
                    </el-table-column>-->


                </el-table>

                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出</el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>
            </div>


            <!-- 图片预览弹窗 (复用同一个弹窗，但内容随点击变化) -->
            <el-dialog
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                width="80%"
                :before-close="handleClose"
                custom-class="photo-dialog-with-labels"
            >
                <div class="photo-gallery">
                    <div v-if="currentPhotoList.length === 0" style="text-align: center; padding: 40px; color: #999;">
                        该组暂无附件
                    </div>

                    <div v-for="(group, gIdx) in currentPhotoList" :key="gIdx" class="photo-group">
                        <div class="photo-group-header">
                            <span class="group-title">{{ group.label }}</span>
                            <span class="group-count">({{ group.files.length }}个)</span>
                        </div>
                        <div class="photo-group-body">
                            <!-- 图片 -->
                            <div v-for="(file, fIdx) in group.files.filter(f => f.isImage)" :key="'img-'+fIdx" class="photo-card">
                                <el-image                                    style="width: 100%; height: 200px; border-radius: 4px;"
                                                                             :src="file.url"
                                                                             :preview-src-list="previewUrlList"
                                                                             fit="cover"
                                                                             lazy
                                >
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                        <span>加载失败</span>
                                    </div>
                                </el-image>
                            </div>
                            <!-- 非图片文件 -->
                            <div v-for="(file, fIdx) in group.files.filter(f => !f.isImage)" :key="'file-'+fIdx" class="photo-card">
                                <div class="file-link-card">
                                    <i class="el-icon-document" style="font-size: 48px; color: #909399;"></i>
                                    <el-link
                                        type="primary"
                                        :href="file.url"
                                        target="_blank"
                                        :underline="false"                                        style="margin-top: 12px; font-size: 14px;">
                                        点击查看文件
                                    </el-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>


            <!-- 编辑确认场次金额弹窗 -->
            <el-dialog
                title="确认活动达标场次详情"
                :visible.sync="editDialogVisible"
                width="80%"
                @close="handleDialogClose"
            >
                <el-table :data="currentDetailList" border stripe>
                    <el-table-column prop="activityType" label="活动类型" width="150" >
                        <template #default="scope">
                            <div
                                v-html="scope.row.activityType || '-'"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activityName" label="活动名称" min-width="120" >
                        <template #default="scope">
                            <div
                                v-html="scope.row.activityName  || '-'"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activityTime" label="活动时间" min-width="80">
                        <template #default="scope">
                            <div
                                v-html="scope.row.activityTime  || '-'"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activityFee" label="活动费用总额(元)" width="120" align="right">
                        <template #default="scope">
                            <div
                                v-html="scope.row.activityFee  || '-'"></div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="confirmFee" label="确认金额(万元)" width="200" align="center">
                        <template #default="scope">
                            <el-input
                                v-model="scope.row.confirmFee"
                                type="number"
                                size="small"
                                placeholder="请输入金额"
                                :disabled="!tgje_confirm"
                                @input="val => onConfirmFeeInput(scope.row, val)"
                            >
                                <template slot="append">万元</template>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="confirmFeePerson" label="金额确认人" width="120" align="right">
                        <template #default="scope">
                            <div
                                v-html="scope.row.confirmFeePerson  || '-'"></div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="isConfirm" label="是否确认场次" width="150" align="center">
                        <template #default="scope">
                            <el-radio-group
                                v-model="scope.row.isConfirm"
                                size="mini"
                                :disabled="!canConfirmSession(scope.row.activityType)"
                            >
                                <el-radio-button :label="1" @click.native="onIsConfirmChange(scope.row, 1)">计入</el-radio-button>
                                <el-radio-button :label="0" @click.native="onIsConfirmChange(scope.row, 0)">不计入</el-radio-button>
                            </el-radio-group>
                        </template>
                    </el-table-column>


                    <el-table-column prop="confirmPerson" label="场次确认人" width="120" align="right">
                        <template #default="scope">
                            <div
                                v-html="scope.row.confirmPerson  || '-'"></div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="80" align="center">
                        <template #default="scope">
                            <span v-if="scope.row.delflag === 0" style="color: #909399;">已删除</span>
                            <el-button
                                v-else
                                type="text"
                                size="small"
                                style="color: #F56C6C;"
                                :disabled="!canConfirmSession(scope.row.activityType)"
                                @click="deleteDetailRow(scope)"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取消</el-button>
                    <el-button type="primary"  :disabled="!canSaveDetail()" @click="saveDetailList">保存</el-button>
                </span>
            </el-dialog>



            <!-- === 附件上传弹窗 === -->
            <el-dialog
                title="上传附件"
                :visible.sync="uploadDialogFile"
                width="500px"
                :close-on-click-modal="false"
            >
                <div style="text-align: center; padding: 20px 0;">
                    <brupload
                        :refid="fileRefId"
                        reftype="市场推广季度报表-上传附件"
                        :uploadflag="true"
                        :delflag="true"
                        :showtime="false">
                    </brupload>
                </div>

                <!-- 按钮组放在内容区域，添加上边距以区分 -->

                <span slot="footer" class="dialog-footer" style="display: flex; justify-content: space-between; width: 100%;">
                    <el-button type="success" @click="handleQualify(fileRefId,'达标')">达标</el-button>
                    <el-button type="danger" @click="handleQualify(fileRefId,'不达标')">不达标</el-button>
                    <el-button @click="uploadDialogFile = false">关 闭</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import marketingReport from "@/api/loud/agent/marketingReport.js";
import updownfile from "@/utils/updownfile";
import weeklyMeetingApi from "@/api/loud/weeklyMeeting/weeklyMeetingApi";
import ss from "@/api/SystemService";
export default {
    data(){
        // 1. 获取当前日期对象
        const now = new Date();

        // 2. 计算当前年份
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth();
        const currentQuarter = Math.floor(currentMonth / 3) + 1;


        return{
            // 展开折叠筛选
            isScreen:false,
            closeScreen:require("@/assets/images/pimg/closeallic.png"),
            drawScreen:require("@/assets/images/pimg/dobleArr.png"),


            editDialogVisible: false,//修改确认场次，金额
            currentDetailList:[],
            submitLoading: false,
            // 弹窗表单数据
            editForm: {
                id: null,
                confirmStandardNum: 0,
                confirmAmountStr: '' // 使用字符串绑定金额输入框，避免 v-model.number 的小数点问题
            },


            uploadDialogFile: false,//上传附件窗口

            q:{
                customerCodeLike: null, //经销商编码或名称
                salechannelCode: null, //渠道
                year:currentYear,//年
                quarter:currentQuarter,//季度
                saleareaCode:null,//省区
                activityType:null,//活动类型
                createMonth:null ,//创建月份
                pageNo:1,
                pageSize: 10,
                total: 0,

            },
            tableData: [],
            currentTime: '',

            dialogVisible: false,
            dialogTitle: '照片预览', // 动态标题
            currentPhotoList: [],    // 当前选中组的详细数据 [{url, categoryName}]
            previewUrlList: [],       // 当前选中组的纯 URL 列表

            fileRefId:null,

            canApproved: false ,//是否能审批

            gxcc_confirm :false , //推广报表高校会场次确认
            qdcc_confirm :false , //推广报表渠道会场次确认
            xscc_confirm :false , //推广报表学术会场次确认
            zhcc_confirm :false , //推广报表地方展会场次确认
            tgje_confirm :false , //推广报表金额确认
            isDls :false , //代理商角色

        }
    },
    methods:{
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        query(){
            console.log(this.q,'查询条件')
            marketingReport.selectPage(this.q).then(res=>{
                console.log(res)
                this.q.total = res.total
                this.tableData = res.records
            })
        },
        //检索
        handleFilter() {
            this.q.pageNo = 1;
            this.query();
        },
        resetData(){
            this.q = {
                pageNo:1,
                pageSize: 10,
                total: 0
            }
            this.query()
        },




        /**
         * 辅助：计算单个分段的图片数量
         */
        getGroupCount(segmentStr) {
            if (!segmentStr) return 0;
            try {
                const obj = JSON.parse(segmentStr.trim());
                let count = 0;
                Object.values(obj).forEach(val => {
                    if (Array.isArray(val)) count += val.length;
                    else if (val) count += 1;
                });
                return count;
            } catch (e) {
                return 0;
            }
        },
        // 判断文件是否为图片
        isImageFile(url) {
            if (!url) return false;
            const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico', 'tiff', 'tif'];
            const ext = url.split('.').pop().toLowerCase().split('?')[0];
            return imageExts.includes(ext);
        },

        // 从 detailList 中提取指定字段
        getDetailListField(row, fieldName) {
            // 优先从 detailList 获取
            if (row.detailList && Array.isArray(row.detailList) && row.detailList.length > 0) {
                const values = row.detailList
                    .map(item => {
                        const val = item[fieldName];
                        if (val === null || val === undefined || val === '') return '-';
                        return String(val).split(';').join('<br/>');
                    });

                return values.join('<br/>');
            }

            // 兼容旧逻辑：直接从 row 获取
            if (row[fieldName]) {
                return String(row[fieldName]).split(';').join('<br/>');
            }

            return '-';
        },

        // 查看一组照片（基于 fileInfoList）
        handleViewGroupPhotosNew(fileInfoList) {
            if (!fileInfoList || fileInfoList.length === 0) {
                this.$message.warning('该组没有附件');
                return;
            }

            const groupsMap = {};
            const urlOnlyList = [];

            fileInfoList.forEach(fileInfo => {
                if (!fileInfo.saveurl) return;

                const reftype = fileInfo.reftype || '未分类';
                if (!groupsMap[reftype]) {
                    let label = reftype;
                    const underscoreIndex = reftype.indexOf('_');
                    if (underscoreIndex !== -1) {
                        label = reftype.substring(underscoreIndex + 1);
                    }
                    groupsMap[reftype] = { reftype: reftype, label: label, files: [] };
                }

                const fullUrl = 'https://' + process.env.VUE_APP_AJAXURL + '/' + fileInfo.saveurl;
                const isImg = this.isImageFile(fileInfo.saveurl);
                groupsMap[reftype].files.push({ url: fullUrl, isImage: isImg });
                if (isImg) {
                    urlOnlyList.push(fullUrl);
                }
            });

            const groupedList = Object.values(groupsMap);

            if (groupedList.length === 0) {
                this.$message.info('该组没有有效的附件');
                return;
            }

            this.dialogTitle = '附件预览';
            this.currentPhotoList = groupedList;
            this.previewUrlList = urlOnlyList;
            this.dialogVisible = true;
        },
        /**
         * 核心方法：点击某一分组，仅解析并展示该组数据
         * @param {String} singleSegmentStr - 单个分号分割后的 JSON 字符串
         */
        handleViewGroupPhotos(singleSegmentStr) {
            const trimmed = singleSegmentStr.trim();
            if (!trimmed) {
                this.$message.warning('数据为空');
                return;
            }

            let obj;
            try {
                obj = JSON.parse(trimmed);
            } catch (e) {
                this.$message.error('照片数据格式解析失败');
                console.error(e);
                return;
            }

            const groupsMap = {};
            const urlOnlyList = [];

            // 遍历当前这唯一的 JSON 对象
            Object.entries(obj).forEach(([categoryName, urls]) => {
                const urlArray = Array.isArray(urls) ? urls : (urls ? [urls] : []);
                if (urlArray.length === 0) return;

                if (!groupsMap[categoryName]) {
                    const label = categoryName || '未分类';
                    groupsMap[categoryName] = {
                        reftype: categoryName,
                        label: label,
                        files: []
                    };
                }

                urlArray.forEach(url => {
                    if (url) {
                        const isImg = this.isImageFile(url);
                        groupsMap[categoryName].files.push({ url: url, isImage: isImg });
                        if (isImg) {
                            urlOnlyList.push(url);
                        }
                    }
                });
            });

            const groupedList = Object.values(groupsMap);

            if (groupedList.length === 0) {
                this.$message.info('该组没有附件');
                return;
            }

            // 设置动态标题
            this.dialogTitle = `附件预览 - ${Object.keys(obj).join(', ')}`;
            this.currentPhotoList = groupedList;
            this.previewUrlList = urlOnlyList;
            this.dialogVisible = true;
        },

        handleClose() {
            this.dialogVisible = false;
            this.currentPhotoList = [];
            this.previewUrlList = [];
            this.dialogTitle = '照片预览';
        },



        /**
         * 格式化百分比
         */
        formatPercent(row, column, cellValue, index) {
            // 1. 防御性编程：如果值为空，返回 '-' 或 '0%'
            if (cellValue === null || cellValue === undefined || cellValue === '') {
                return '-';
            }
            const percentValue = cellValue * 100;

            return `${percentValue}%`;

        },
        /**
         * 格式化金额：保留2位小数，千分位
         */
        formatMoney(value) {
            if (value === null || value === undefined || value === '') return '0.00';
            const num = parseFloat(value);
            if (isNaN(num)) return '0.00';
            return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },


        // 打开编辑弹窗
        openEditDialogNew(row) {
            this.currentRow = row;
            // 深拷贝 detailList，避免直接修改原数据
            this.currentDetailList = JSON.parse(JSON.stringify(row.detailList || []));
            this.editDialogVisible = true;
        },
        // 获取确认达标场次数量
        getConfirmCount(row) {
            if (row.detailList && Array.isArray(row.detailList) && row.detailList.length > 0) {
                return row.detailList.filter(item => item.isConfirm === 1).length;
            }
            return row.confirmStandardNum || 0;
        },

        // 金额输入时实时记录确认人
        onConfirmFeeInput(row, val) {
            row.confirmFeePerson = val && String(val).trim() !== ''
                ? this._user.username + '(' + this._user.usercode + ')' : '';
        },


        onIsConfirmChange(row, val) {
            // 无权限时不记录（disabled 状态下 label 的原生 click 仍可能冒泡触发）
            if (!this.canConfirmSession(row.activityType)) return;
            row.confirmPerson = this._user.username + '(' + this._user.usercode + ')';
        },

        deleteDetailRow(scope) {
            this.$msg.confirm('是否确认删除该条场次数据？删除后需点击保存生效。', () => {
                this.$set(scope.row, 'delflag', 0);
             });
        },


        /**
         * 2. 关闭弹窗时的清理
         */
        handleDialogClose() {
            this.currentEditingRow = null;
            this.editForm = { id: null, confirmStandardNum: 0, confirmAmountStr: '' };
        },

        // 保存 detailList 数据
        saveDetailList() {

            // 更新原数据的 detailList
            this.currentRow.detailList = JSON.parse(JSON.stringify(this.currentDetailList));

            if(this.currentRow.detailList.length==0){
                this.$message.error('无可确认数据!');
                return; // 阻止继续执行
            }

            //要调用更新接口
            marketingReport.updateReportDetail(this.currentRow.detailList).then(res=>{
                    this.$message.success('更新成功');
                    this.editDialogVisible = false;
                    this.query();
                })
                .catch(err => {
                    console.error(err);
                    this.$message.error('更新失败，请重试');
                })
                .finally(() => {
                    this.editDialogVisible = false;
                });

        },



        /*上传附件弹窗*/
        uoloadFile(row){

         /*   if (!this.canApproved) {
                // 2. 无权限提示
                this.$message.warning('您没有操作权限，无法修改确认达标场次。');
                return;
            }*/
            //已审核通过
           /* if (row.approved) {
                this.$message.warning('该条信息已审核，无法修改！');
                return;
            }*/

            this.fileRefId = row.id;
            this.uploadDialogFile = true;
        },
        //判断是否达标
        handleQualify(id,yewuStandard) {

                const params = {
                    id: id,
                    yewuStandard:yewuStandard
                };
                marketingReport.updateStandard(params)
                    .then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    })
                    .catch(err => {
                        console.error(err);
                        this.$message.error('更新失败，请重试');
                    })


            //关闭弹窗
            this.uploadDialogFile = false;
        },


        //导出Excel
        exportExcel(){
            updownfile.down("/api/swyl/v1/hetong/BscMarketingReport/downloadExcel", this.q, "post");
        },

        //审核
        updateApproved(row){
            //已审核通过
            if (row.approved) {
                this.$message.warning('该条信息已审核，无法修改！');
                return;
            }
            this.$msg.confirm("是否确认审核? 审核后数据将无法修改！", () => {
                const params = {
                    id: row.id,
                };
                marketingReport.updateApproved(params)
                    .then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    })
                    .catch(err => {
                        console.error(err);
                        this.$message.error('更新失败，请重试');
                    })
            });


        },

        // 判断是否可以确认场次（根据活动类型和角色）
        canConfirmSession(activityType) {
            if (!activityType) return false;

            // 高校巡展
            if (activityType === '高校巡展/实验室安全讲座演练') {
                return this.gxcc_confirm;
            }
            // 渠道会用户会
            if (activityType === '渠道客户会/用户会') {
                return this.qdcc_confirm;
            }
            // 区域展会
            if (activityType === '区域展会') {
                return this.zhcc_confirm;
            }
            // 学术会
            if (activityType === '学术会') {
                return this.xscc_confirm;
            }


            return false;
        },

        // 判断是否可以保存（有确认金额权限或任意场次确认权限）
        canSaveDetail() {
            return this.tgje_confirm || this.gxcc_confirm || this.qdcc_confirm || this.zhcc_confirm || this.xscc_confirm;
        }
    },



    created() {
        //审核角色 （作废）
        this.canApproved = this.$store.getters.hasRole('marketing_report_approved')  || this.$store.getters.hasRole('swyl_admin');

        this.gxcc_confirm = this.$store.getters.hasRole('gxcc_confirm,swyl_admin,tgje_confirm'); //推广报表高校会场次确认
        this.qdcc_confirm = this.$store.getters.hasRole('qdcc_confirm,swyl_admin,tgje_confirm'); //推广报表渠道会场次确认
        this.xscc_confirm = this.$store.getters.hasRole('xscc_confirm,swyl_admin,tgje_confirm'); //推广报表学术会场次确认
        this.zhcc_confirm = this.$store.getters.hasRole('zhcc_confirm,swyl_admin,tgje_confirm'); //推广报表地方展会场次确认
        this.tgje_confirm = this.$store.getters.hasRole('tgje_confirm,swyl_admin'); //推广报表金额确认

        this.isDls = this.$store.getters.hasRole('swyl_dailishang,swyl_gndailishang'); //代理商



        this.currentTime = moment(new Date()).format('YYYY-MM-DD')
        this.query()
    },
    activated() {
        this.query()
    }





}
</script>

<style scoped>
/* 容器：垂直排列每一组 */
.photo-segments-container {
    display: flex;
    flex-direction: column;
    gap: 8px; /* 组与组之间的间距 */
}

/* 单个组条目 */
.photo-segment-item {
    font-size: 13px;
}

.segment-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f5f7fa; /* 给每组加个淡背景，区分明显 */
    padding: 6px 10px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

/* 左侧显示的分类标签文字 */
.segment-label {
    color: #606266;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 60%; /* 防止文字太长挤占按钮位置 */
    margin-right: 10px;
}

/* 右侧的查看按钮 */
.view-btn {
    font-size: 12px;
    flex-shrink: 0; /* 防止按钮被压缩 */
}

/* --- 弹窗样式 (保持之前的逻辑) --- */
.photo-gallery {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 20px;
    max-height: 70vh;
    overflow-y: auto;
    padding: 10px;
}

.photo-card {
    width: 220px;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
    transition: transform 0.2s;
}

.photo-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px 0 rgba(0,0,0,0.1);
}

.photo-label {
    padding: 8px;
    text-align: center;
    background-color: #fafafa;
    border-top: 1px solid #f0f0f0;
}

.image-slot {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 14px;
}
.image-slot i {
    font-size: 30px;
    margin-bottom: 5px;
}
/* 分组 */
.photo-group {
    margin-bottom: 24px;
}
.photo-group-header {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 2px solid #409EFF;
    margin-bottom: 12px;
}
.group-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}
.group-count {
    margin-left: 8px;
    font-size: 13px;
    color: #909399;
}
.photo-group-body {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.file-link-card {
    width: 100%;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    border-radius: 4px;
    border: 1px dashed #dcdfe6;
}
</style>

